module.exports = __webpack_public_path__ + "static/media/PDF17.febdb2a1.pdf";